import cloneDeep from 'lodash/cloneDeep'
import { sortArrayBy } from '@domain-group/javascript-utils'

import type { ProviderPriceListItemOptionModel } from '@models/types'
import type { EntitiesState } from '@redux/entities'

export type SelectedOption = {
  id: number,
  title: string,
  value: {
    id: number,
    price: number,
    provider_product_option_value_code: string,
    title: string,
    is_default?: boolean,
    is_upgrade?: boolean,
    is_downgrade?: boolean,
  },
}

type SelectPriceListItemOptionValueParams = {
  providerPriceListItemOption: ProviderPriceListItemOptionModel,
  providerPriceListItemOptionValues: EntitiesState['providerPriceListItemOptionValues'],
  selectedProviderPriceListItemOptionValueId: number,
  selectedProviderPriceListItemOptions: SelectedOption[],
}

const selectPriceListItemOptionValue = (params: SelectPriceListItemOptionValueParams) => {
  const {
    providerPriceListItemOption,
    providerPriceListItemOptionValues,
    selectedProviderPriceListItemOptionValueId,
    selectedProviderPriceListItemOptions,
  } = params

  const currentOptionIds = selectedProviderPriceListItemOptions.map(option => option.id)

  const selectedOptions: SelectedOption[] = cloneDeep(selectedProviderPriceListItemOptions)

  const selectedOptionValue = providerPriceListItemOptionValues[selectedProviderPriceListItemOptionValueId]

  // Check if exists, then remove
  if (selectedOptions.length){
    const existingIndex = selectedOptions.findIndex(currentOption => (
      providerPriceListItemOption.id === currentOption.id
    ))

    if (existingIndex !== -1){
      selectedOptions.splice(existingIndex, 1)
    }
  }

  if (selectedOptionValue && selectedProviderPriceListItemOptionValueId){
    // Setup the new option
    const newOption = {
      id: providerPriceListItemOption.id,
      title: providerPriceListItemOption.title || `Option ${providerPriceListItemOption.id}`,
      value: {
        id: Number(selectedProviderPriceListItemOptionValueId) || selectedProviderPriceListItemOptionValueId,
        is_default: !!selectedOptionValue.is_default,
        is_upgrade: !!selectedOptionValue.is_upgrade,
        is_downgrade: !!selectedOptionValue.is_downgrade,
        title: selectedOptionValue.title,
        price: selectedOptionValue.price,
        provider_product_option_value_code: selectedOptionValue.product_code,
      },
    }

    // Add this option
    // @ts-expect-error TS2345
    selectedOptions.push(newOption)
  }

  const sortedSelectedOptions = sortArrayBy(selectedOptions, 'asc', (selectedOption) => {
    const index = currentOptionIds.findIndex(id => id === selectedOption.id)
    return index
  })

  return { selectedProviderPriceListItemOptions: sortedSelectedOptions }
}

export default selectPriceListItemOptionValue
